import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import _ from "lodash";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const REACardAreaSection = (props) => {

    const {
        totalREA,
        extraHeader,
        realEstateAgent,
        isMobile,
        actualCoursesList,
        setLoadSpin,
        loadSpin,
        setCount,
        counter,
        setCounter,
        check,
        cmpletionText,
        isDetail,
        isLP,
        courseOrVideo,
        selectedFilters
    } = props

    const navigate = useNavigate()
    const {t} = useTranslation();
    return (
        <section className="progress-box-report">
            <div className="container-pwc">
                <div className="row">
                    <div className="col-md-12 flex-titlereport d-flex justify-content-between align-items-baseline">
                        <div className="progess-count-tiel">
                            {t("End user")}&nbsp;
                            <strong>({totalREA
                            })</strong> {extraHeader}
                        </div>
                        {/* SORT BY oR FILTER */}
                        {/* {false && <div className="input-text fliterreportsgen">
                            <label htmlFor="filter" className="input__label">
                                Sort By
                            </label>
                            <select
                                type="text"
                                id="filter"
                                name="filter"
                                className="form-select input_searchfield mb-0 session-filter"
                                value={filterBy}
                                onChange={onClickFilterBy}
                            >
                                {FILTER_BY.map((item, index) => {
                                    return (
                                        <option seleted key={index}>
                                            {item.value}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>} */}
                    </div>
                </div>
                <div className="row mt-3">
                    {(!_.isEmpty(realEstateAgent)) ? realEstateAgent?.map((m, index) => {
                        return (
                            <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report" key={index}>
                                <div className="reopor-box-progess">
                                    <div className="progess-profile d-flex">
                                        <div className="user-progess-img">
                                            <img src={m?.profile_pic} width="48" height="48" />
                                        </div>
                                        <div className={`userprogress-details ${(m?.is_allow === true && false) ? "cursor-pointer" : "cursor-not-allowed"}`}>
                                            <h5
                                                className="user-tiele"
                                                onClick={() => {
                                                    if (m?.is_allow === true && false) {
                                                        navigate(`/profile/edit?section=edit&user_id=${m?.uid}`);
                                                    }
                                                }}
                                            >
                                                {m?.user_name}
                                            </h5>
                                            <OverlayTrigger
                                                key='bottom'
                                                placement='bottom'
                                                overlay={
                                                    <Tooltip id={`tooltip-bottom`}>
                                                        <div
                                                            style={{
                                                                color: "white",
                                                                backgroundColor: "transparent",
                                                            }}

                                                        >{m?.office_name}</div>
                                                    </Tooltip>
                                                }
                                            >
                                                <p >{m?.office_name}</p>
                                            </OverlayTrigger>
                                            {/* <p>{m?.office_name}</p> */}
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="progress-details">
                                        <div class="progess-report-graph">
                                            <div class="circlebox">
                                                <div
                                                    className="circularProgress-sm"
                                                    style={{
                                                        width: 72,
                                                        height: 72,
                                                        position: "relative",
                                                    }}
                                                >
                                                    <CircularProgressbar
                                                        value={m?.learning_percentage}
                                                        strokeWidth={8}
                                                        styles={buildStyles({
                                                            pathColor: "#415385", //FF9700=yellow
                                                            trailColor: "#EBEBEB",
                                                        })
                                                        }
                                                    />
                                                    <div className="centerprogess-con"
                                                        style={{
                                                            position: "absolute",
                                                            top: "1.2rem",
                                                            width: "72px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {true ? (
                                                            <>
                                                                <strong
                                                                    style={{ color: "#415385" }}
                                                                >{`${m?.learning_percentage}%`}</strong>
                                                                <small>{t("Progress")}</small>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="progess-count-show-new">
                                            <div class="learning-points-new">
                                                <strong>{m?.total_completed}/</strong>{m?.total_assigned}
                                            </div>
                                            <div class="learning-points-name">
                                                {cmpletionText}
                                            </div>
                                        </div>

                                    </div>
                                    {isDetail ? <div className="prog-link"></div> : <div className="prog-link" onClick={() => {
                                        localStorage.setItem('SELECTED_FILTER', JSON.stringify({
                                            isLP: (window.location.pathname.includes('/lp-report') || isLP),
                                            selectedFilters
                                        }))
                                        if (window.location.pathname.includes('/lp-report') || isLP) {
                                            let url = isMobile ? "/lp-report-rea-mobile-detail" : "/lp-report-rea-detail";
                                            url = url + "?id=" + m.uid + "&isCompliance=" + (check ? 1 : 0);
                                            navigate(url)

                                        } else {
                                            let url = isMobile ? '/compliance-report-agent-detail-mobile' : '/compliance-report-agent-detail';
                                            url = url + '?id=' + m.uid + "&isCompliance=" + (check ? 1 : 0) + "&isAgent=true";
                                            if(courseOrVideo)
                                            {
                                              url = url + "&isVideos=true";
                                            } 
                                            else
                                            {
                                              url = url + "&isVideos=false";
                                            }
                                            navigate(url)
                                        }
                                    }} >
                                        {t("viewMore")}
                                    </div>}
                                </div>
                            </div>
                        );
                    })
                        :
                        <div className="col-md-12">
                            <div className="not-found mt-3">
                                <div className="interboxes">
                                    <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" />
                                    {/* <p>{`${t("The Participants that are assigned for")} ${courseOrVideo ? t("videos") : t("courses")} ${t("will be shown on this section.")}`}</p> */}
                                    <p>The End User that are assigned for Online Asset will be shown on this section.</p>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="col-md-12 mt-3">
                        <p className="text-center">
                            {actualCoursesList?.length === 0 || totalREA === realEstateAgent?.length ? "" :
                                <button
                                    type="button"
                                    id="number"
                                    className="btn btn-primary-complete"
                                    onClick={() => {
                                        setCount(counter, setCounter);
                                        setLoadSpin(true);
                                    }
                                    }
                                >
                                    {(loadSpin) ?
                                        <div className="d-flex justify-content-center w-100">
                                            <Spinner animation="border" />
                                        </div>
                                        : t("Load More")}
                                </button>
                            }
                            {/* {(_.isEmpty(limitStatus)) ?
                  "" :
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "Load More"}
                  </button>
                } */}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default REACardAreaSection